module.exports = __webpack_public_path__ + "static/media/carrot-logo-orange-xmas-crop.e1e46722.png";